import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Icon = ({
	icon,
	title = '',
	classes = '',
	spin = false,
}) => {
	if (!icon) {
		return null;
	}

	const normalizedIcon = typeof icon === 'string' ? ['fas', icon] : icon;

	return (
		<div className={`icon__container ${classes}`} title={title}>
			<FontAwesomeIcon className="" icon={normalizedIcon} spin={spin} />
		</div>
	);
};

export default Icon;

Icon.propTypes = {
	icon: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.shape({
			prefix: PropTypes.string,
			iconName: PropTypes.string,
		}),
	]),
	title: PropTypes.string,
	classes: PropTypes.string,
	spin: PropTypes.bool,
};
